module.exports = __webpack_public_path__ + "static/media/22.bd10e4b2.mp3";